
<div class="priority-header row justify-content-between no-gutters">
  <div>{{priority.PriorityName}}</div>
  <div>{{priority.TaskCountTotal ? priority.TaskCountTotal : 0}}</div>
</div>

<div class="stage row align-items-center justify-content-end" *ngFor="let cat of priority.Categories">
  <div class="col-md-auto label-text">{{ getCategoryDisplayName(cat.CategoryName) }}</div>
  <div class="progress">
    <div class="progress-bar progress-complete" role="progressbar"
         [style.width]="cat.PercentComplete+'%'" attr.aria-valuenow="{{cat.PercentComplete}}" aria-valuemin="0" aria-valuemax="100" [attr.title]="cat.PercentComplete + '%'">
    </div>
    <div class="progress-bar progress-inprogress" role="progressbar"
         [style.width]="cat.PercentInProgress+'%'" attr.aria-valuenow="{{cat.PercentInProgress}}" aria-valuemin="0" aria-valuemax="100" [attr.title]="cat.PercentComplete + '%'">
    </div>
    <div class="progress-bar progress-incomplete" role="progressbar"
         [style.width]="cat.PercentIncomplete+'%'" attr.aria-valuenow="{{cat.PercentIncomplete}}" aria-valuemin="0" aria-valuemax="100" [attr.title]="cat.PercentComplete + '%'">
    </div>
  </div>
  <div class="col col-md-2 label-text">{{cat.PercentComplete}}%</div>
</div>

